// ============================================================
// shared/src/roles.ts
// ★ Role 枚举 (ADMIN/OPS/TECH/PARTNER/DOWNSTREAM)
// ============================================================

export enum Role {
  ADMIN      = 'ADMIN',
  OPS        = 'OPS',
  TECH       = 'TECH',
  PARTNER    = 'PARTNER',
  DOWNSTREAM = 'DOWNSTREAM',
}

/** 内部角色（可查看明文数据的角色） */
export const PLAINTEXT_ROLES: Role[] = [Role.ADMIN, Role.TECH];

/** 可访问看板的角色 */
export const DASHBOARD_ROLES: Role[] = [Role.ADMIN, Role.OPS, Role.TECH];

/** 可按 scope 过滤数据的角色 */
export const SCOPED_ROLES: Role[] = [Role.PARTNER, Role.DOWNSTREAM];
